module.exports = __webpack_public_path__ + "img/broadcast-school-icon1.ba955104.png";